<template>
    <!-- lista foto -->
    <div class="p-md-3" v-if="graphic_layout">
        <div class="row">
            <div class="col-md-4 prodotti-foto mb-3" v-for="product in this.products">
                <div class="item d-md-flex justify-content-center flex-md-column h-100">
                  <div>
                        <router-link
                            :to="{name:'menu.category.product',params:{id:product.id,category_id:getCategoryId(product)}}">
                            <img :src="getProductImage(product.foto_codice)" class="img-fluid img-center">
                        </router-link>
                        <div class="qta-price d-flex flex-row align-items-center justify-content-end">
                            <div class="quantita-carrello" v-if="getTotalPerProduct(product.id)">
                              {{ getTotalPerProduct(product.id) }}
                            </div>
                            <inc-product-price-label :currency="locale_currency" :product="product"
                                                     :graphic-layout="graphic_layout"/>
                        </div>
                  </div>
                    <div class="dati p-3">
                        <p class="nome">
                            <router-link
                                :to="{name:'menu.category.product',params:{id:product.id,category_id:getCategoryId(product)}}"
                                class="a3">
                                {{ product.nome }}
                            </router-link>
                        </p>
                        <p class="ingredienti-foto truncate-2 lh18">
                             <span v-if="f_deliverect">
                               {{ product.descrizione }}
                            </span>
                            <span v-else v-for="(ingredient, i) in product.ingredienti"
                                  :class="{'font-weight-bold': ingredient.allergeni}">
                                {{ ingredient.alias }}{{ parseInt(i) === (product.ingredienti.length - 1) ? "" : ", " }}
                            </span>
                        </p>
                    </div>
                    <button class="btn btn-primary piu_foto mx-md-3 mt-md-auto"
                            @click="$router.push({name:'menu.category.product',params:{id:product.id,category_id:getCategoryId(product)}})">
                        {{ $t('aggiungi') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- fine lista foto -->

    <!-- lista no foto -->
    <div class="row" v-else>
        <div class="col-12" v-for="product in this.products">
            <div class="item mb-0 p-3 border-bottom">
                <div class="dati">
                    <p class="nome mb-0">
                        <router-link
                            :to="{name:'menu.category.product',params:{id:product.id,category_id:getCategoryId(product)}}"
                            class="a3">
                            {{ product.nome }}
                        </router-link>
                    </p>
                    <p class="ingredienti truncate-2">
                        <span v-if="f_deliverect">
                           {{ product.descrizione }}
                        </span>
                        <span v-else v-for="(ingredient, i) in product.ingredienti"
                              :class="{'font-weight-bold': ingredient.allergeni}">
                            {{ ingredient.alias }}{{ parseInt(i) === (product.ingredienti.length - 1) ? "" : ", " }}
                        </span>
                    </p>

                    <div class="d-flex justify-content-between align-items-center prodotti-nofoto">
                        <div class="d-flex align-items-center flex-grow-1">
                            <inc-product-price-label :product="product" :currency="locale_currency"
                                                     :graphic-layout="graphic_layout"/>
                            <div class="quantita-carrello ml-3" v-if="getTotalPerProduct(product.id)">
                              {{ getTotalPerProduct(product.id) }}
                            </div>
                      </div>
                      <button class="btn btn-primary w-auto piu"
                              @click="$router.push({name:'menu.category.product',params:{id:product.id,category_id:getCategoryId(product)}})">
                        {{ $t('aggiungi') }}
                      </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- fine no foto -->
    </div><!-- /.row -->
</template>

<script>
import {mapGetters, mapState} from 'vuex';

import IncProductPriceLabel from './IncProductPriceLabel';

import {getImage} from '../../../api/core';

export default {
    name: "IncProductList",
    components: {IncProductPriceLabel},
    props: ['products', 'categoryId'],
    computed: {
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            f_deliverect: state => state.f_deliverect
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapGetters('restaurant', {
            graphic_layout: 'graphicLayout',
            locale_currency: 'localeCurrency'
        }),
        ...mapState('order', {
            order: state => state
        })
    },
    methods: {
        getTotalPerProduct: function (id) {
            let total = 0;

            this.order.items.forEach((item) => {
                if (item.item.id === id) {
                    total += item.quantity;
                }
            });

            return total;
        },
        getProductImage: function (code) {
            return getImage(this.language, this.id_ristorante, code);
        },
        getCategoryId: function (product) {
            if (this.categoryId) {
                return this.categoryId;
            }

            try {
                return product.categorie[0].id;
            } catch (e) {
                return 0;
            }
        }
    }
}
</script>
